<template>
  <div>
    <div
      v-if="GET_ACCOUNT_DATA.id == 1 || has_perm('update_case')"
      style="border: 0px solid black; width:100%;"
    >
      <div class="welcome" style="border: 0px solid red;">
        <row
          style="border:0px solid green;position: inherit;display:contents;width:100%;"
        >
          <div class="box box-primary">
            <div class="box-header with-border">
              <div
                style="text-align:center; font-size: 17px;text-align:left;color:#5b6c7f;margin-bottom:20px;"
              >
                <b>{{ $t("common.history") }}</b>
              </div>
            </div>
            <div class="box-body">
              <!-- B-Table Start -->
              <b-table
                :items="gridDataList"
                :fields="gridColumns"
                class="mt-3"
                outlined
                responsive
              >
                <template #head()="scope">
                  <div>{{ $t(scope.label) }}</div>
                </template>
                <template #cell(action)="row">
                  {{ $t(row.item.action) }}
                </template>
                <template #cell(status)="row">
                  {{ $t(getmaintenanceStatus(row.item.status)) }}
                </template>
              </b-table>
              <!-- B-Table End -->
            </div>
            <div class="box-footer clearfix" style="display:contents;">
              <div class="col-md-12">
                <paginator
                  :totalItem="paginateData.totalItem"
                  :currentPage="paginateData.currentPage"
                  :pageSize="paginateData.pageSize"
                  :totalPage="paginateData.totalPage"
                  @onpaginate="onPagination"
                />
              </div>
            </div>
          </div>
        </row>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import utils from "@/lib/utils";
import Enum from "../../../enum/enum";
import constantsData from "@/lib/constantsData";
import feedbackStatusEnum from "@/enum/feedbackStatusEnum";
import Paginator from "@/components/CustomPaginator.vue";

export default {
  components: {
    paginator: Paginator
  },
  props: {
    assetId: {
      type: Number,
      default: () => {
        return 0;
      }
    }
  },
  data: () => ({
    gridColumns: [
      // {
      //   label: "common.nonumber",
      //   key: "nonumber",
      //   class: "text-center"
      // },
      {
        key: "maintenanceCode",
        label: "common.code",
        sortable: false
      },
      {
        label: "propertyMaintenance.typeOfMaintenance",
        key: "typeOfMaintenance",
        class: "text-center"
      },
      {
        label: "propertyMaintenance.implementationDate",
        key: "maintainanceStartDate",
        class: "text-center"
      },
      {
        label: "propertyMaintenance.assignTo",
        key: "maintenancePersonnel",
        class: "text-center"
      },
      {
        label: "propertyMaintenance.activity",
        key: "status",
        class: "text-center"
      },
      {
        key: "dateCreate",
        label: "common.dateCreate",
        class: "text-center"
      },
      {
        label: "feedback.history.interactivePerson",
        key: "interactivePerson",
        class: "text-center"
      }
    ],
    gridDataList: [],
    paginateData: {
      totalItem: 1,
      currentPage: 1,
      pageSize: 1,
      totalPage: 1
    },
    isLoading: false,
    statusList: [
      { value: feedbackStatusEnum.CREATE, text: "feedback.statusList.new" },
      {
        value: feedbackStatusEnum.RECEIVED,
        text: "feedback.statusList.received"
      },
      { value: feedbackStatusEnum.DONE, text: "feedback.statusList.done" },
      {
        value: feedbackStatusEnum.CANCELED,
        text: "feedback.statusList.canceled"
      },
      {
        value: feedbackStatusEnum.IN_PROGRESS,
        text: "feedback.statusList.doing"
      },
      {
        value: feedbackStatusEnum.IN_PROGRESS_DOING,
        text: "feedback.statusList.IN_PROGRESS_DOING"
      },
      {
        value: feedbackStatusEnum.IN_PROGRESS_DONE,
        text: "feedback.statusList.IN_PROGRESS_DONE"
      },
      {
        value: feedbackStatusEnum.IN_PROGRESS_CANCEL,
        text: "feedback.statusList.IN_PROGRESS_CANCEL"
      }
    ],
    maintenanceStatusList: constantsData.maintenanceStatusList
  }),
  watch: {
    assetId: function() {
      if (this.assetId !== null && this.assetId !== 0) {
        this.getAssetDetailHistory(1);
      }
    },
    GET_ASSET_DETAIL_MAINTENANCE_HISTORY_LIST_DATA: function() {
      let paginate = this.GET_ASSET_DETAIL_MAINTENANCE_HISTORY_LIST_DATA
        .paginate;
      this.paginateData = {
        totalItem: paginate.totalItem,
        currentPage: paginate.currentPage,
        pageSize: paginate.pageSize,
        totalPage: paginate.numPages
      };
      let data = this.GET_ASSET_DETAIL_MAINTENANCE_HISTORY_LIST_DATA.results;
      this.gridDataList = [];
      data.forEach((element, i) => {
        let id = element.id;
        let nonumber = i + 1 + (paginate.currentPage - 1) * paginate.pageSize;
        let interactivePerson = element.user_created_data.full_name;
        // let status = element.status
        // let oldStatus = i > 0 ? data[i - 1].status : null
        // maintenance type
        let maintenanceType = utils.getCleanStringValue(element.maintenance_type_data.default, "");
        let maintenanceFunction = utils.getCleanStringValue(element.maintenance_function_data.default, "");
        let typeOfMaintenance = utils.isEmptyString(maintenanceFunction) ? maintenanceType : maintenanceType + " - " + maintenanceFunction;
        // maintainance_date
        let maintainanceDate = utils.formatSqlDate(element.maintainance_date, null, "DD/MM/YYYY");
        let item = {
          id: id,
          nonumber: nonumber,
          interactivePerson: interactivePerson,
          // action: this.getStatusValue(oldStatus, status, element.action, element.feedback_history_content),
          dateCreate: utils.formatSqlDate(element.date_created, null, "HH:mm DD/MM/YYYY"),
          typeOfMaintenance: typeOfMaintenance,
          maintainanceStartDate: maintainanceDate,
          maintenancePersonnel: element.contacter_data.full_name,
          status: element.status,
          maintenanceCode: element.code
        };
        this.gridDataList.push(item);
      });
      // this.gridDataList.reverse();
    }
  },
  computed: {
    ...mapGetters([
      "GET_ACCOUNT_DATA",
      "GET_ASSET_DETAIL_MAINTENANCE_HISTORY_LIST_DATA"
    ])
  },
  methods: {
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    getStatusValue: function(oldStatus, newStatus, actionValue, comment) {
      if (oldStatus === null) {
        return this.getStatusName(newStatus);
      } else {
        if (oldStatus !== newStatus) {
          return this.getStatusName(newStatus);
          //
        } else {
          if (
            actionValue === Enum.ActionHistoryEnum.UPDATE &&
            comment === null
          ) {
            // update feedback
            return "project_history.update";
          }
          if (
            actionValue === Enum.ActionHistoryEnum.UPDATE &&
            comment !== null
          ) {
            return "common.comment";
          }
        }
      }
    },
    getAssetDetailHistory: function(page) {
      let filter = {
        id: this.assetId,
        params: {
          page: page,
          page_size: 10
        }
      };
      this.GET_ASSET_DETAIL_MAINTENANCE_HISTORY(filter)
        .then(
          function() {
            this.isLoading = false;
          }.bind(this)
        )
        .catch(
          function(error) {
            this.isLoading = false;
          }.bind(this)
        );
    },
    onPagination: function(data) {
      this.getAssetDetailHistory(data);
    },
    getStatusName: function(statusValue) {
      let results = "";
      let index = this.statusList.findIndex(x => x.value === statusValue);
      results = index !== -1 ? this.statusList[index].text : "";
      return results;
    },
    getmaintenanceStatus: function(value) {
      let index = this.maintenanceStatusList.findIndex(x => x.value === value);
      return index !== -1 ? this.maintenanceStatusList[index].text : "";
    },
    ...mapActions([
      "GET_ASSET_DETAIL_MAINTENANCE_HISTORY"
    ])
  },
  mounted() {
    if (this.assetId !== null && this.assetId !== 0) {
      this.getAssetDetailHistory(1);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Property/DetailAssetHistory.vue